import { type FC, useState } from 'react'
import { CheckCircle2, Copy } from 'lucide-react'
import { cn } from '@/lib/utils'

interface CopyButtonProps {
    text: string
    className?: string
    iconClassName?: string
}

const CopyButton: FC<CopyButtonProps> = ({
    text,
    className,
    iconClassName,
}) => {
    const [copied, setCopied] = useState(false)

    const handleCopy = async (e: React.MouseEvent) => {
        e.stopPropagation()
        await navigator.clipboard.writeText(text)
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
    }

    return (
        <button
            onClick={handleCopy}
            className={cn(
                'inline-flex h-4 w-4 items-center justify-center text-muted-foreground hover:text-foreground',
                className
            )}
            title="Copy"
        >
            {copied ? (
                <CheckCircle2
                    className={cn('h-3 w-3 text-green-600', iconClassName)}
                />
            ) : (
                <Copy
                    className={cn(
                        'h-3 w-3 text-muted-foreground hover:text-foreground',
                        iconClassName
                    )}
                />
            )}
        </button>
    )
}

export default CopyButton
